// extracted by mini-css-extract-plugin
export default {"copyRightFooter":"copyRightFooter_copyRightFooter__9Y6nB","h4":"copyRightFooter_h4__PSBSr","h3":"copyRightFooter_h3__4irsH","span":"copyRightFooter_span__UwCr4"};